module.exports = __webpack_public_path__ + "img/help.26c2935b.png";